const state = {
  area: {
    content: [],
    count: 0,
  },
  myArea: {
    current: {},
    nearby: [],
  },
};

export default state;
